module.exports = __webpack_public_path__ + "img/html5.f0361c5e.svg";